import React, { useEffect } from "react";
import CommonLayout from "../layout/CommonLayout";
import tick from "../assets/images/icons/tickicon.svg";
import OrderHistory from "../components/orderSuccessfullElement/OrderHistory";
import CommonButton from "../components/CommonButton";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDomainInfo } from "../utils/utils";

export default function OrderSuccessfull() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userId } = useParams();
  const { hostname, isPredefinedDomain, uid } = getDomainInfo(userId);
  const userImg = useSelector((state) => state.fetchUser?.user?.profileImg);
  const { neworderId, paymentType, orderDateTime, orderAmount, skuIds } =
    location.state || {};

  const handleClick = () => {
    navigate(isPredefinedDomain ? `/${uid}` : "/");
  };
  const handleViewOrder = () => {
    navigate(isPredefinedDomain ? `/${uid}/order-history` : "/order-history");
  };

  const defaultImageUrl = process.env.REACT_APP_S3_URL || "/assets/images/defultprofileimage.png";

  const imageUrl = userImg && userImg.includes("https://hello-image-bucket.s3")
    ? userImg
    : defaultImageUrl + userImg;

  useEffect(() => {
    if (!window.fbq || !neworderId || !orderAmount) {
      console.warn("fbq or order data missing, Purchase event not fired");
      return;
    }


    window.fbq('track', 'Purchase', {
      content_ids: Array.isArray(skuIds) ? skuIds : [],
      value: parseFloat(orderAmount).toFixed(2),
      currency: 'INR',
      content_type: 'product',
    });

  }, [neworderId, orderAmount, skuIds]);

  return (
    <CommonLayout>
      <div className="rootCommonBox">
        <div className="customCardBox">
          <img src={imageUrl} alt="Profile" className="profile-img" onClick={handleClick} />
          <div
            style={{
              marginTop: "50px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "18px",
            }}
          >
            <img height={"70px"} width={"70px"} src={tick} alt="" />
            <p
              style={{
                fontWeight: "800",
                fontSize: "20",
                color: "#000",
                marginBottom: "0px",
              }}
              className={"headingfonts"}
            >
              Order placed successfully
            </p>
            <div style={{ textAlign: "center" }} className={"fontclass"}>
              <OrderHistory detail={"Order Number"} value={neworderId} />
              <OrderHistory detail={"Payment Type"} value={paymentType} />
              <OrderHistory detail={"Order Date & Time"} value={orderDateTime} />
              <OrderHistory detail={"Order Amount"} value={`Rs. ${orderAmount}`} />
            </div>
            <div>
              <CommonButton
                name={"Let’s Shop More"}
                width={"80%"}
                onClick={handleClick}
              />
              <CommonButton
                name={"View Order"}
                width={"80%"}
                onClick={handleViewOrder}
              />
            </div>
          </div>
        </div></div>
    </CommonLayout>
  );
}
